import api from "..";

export const getAdminDashboardStats = (params = {}, callBack) => {
    api.get(`/admin/company-stats/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getOnboardingRequests = (params = {}, callBack) => {
    api.get(`/onboard-requests/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getSingleOnboardingRequest = (id, callBack) => {
    api.get(`/onboard-requests/${id}/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        })
}

export const onBoardingApprovalOrRejection = (id, data, callBack) => {
    api.post(`/onboard-requests/${id}/status/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getChangeRequests = (params = {}, callBack) => {
    api.get(`/change-requests/`, { params })
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};

export const getSingleChangeRequest = (id, callBack) => {
    api.get(`/change-requests/${id}/`)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        })
}

export const ChangeRequestApprovalOrRejection = (id, data, callBack) => {
    api.post(`/change-requests/${id}/status/`, data)
        .then((response) => {
            callBack(response?.data);
        })
        .catch((error) => {
            callBack(error?.response);
        });
};





